import { startOfDay } from 'date-fns';

export function getSchoolYearDateRange() {
  const today = startOfDay(new Date());
  const schoolYearStart = new Date(today.getFullYear(), 6, 15);

  const from =
    schoolYearStart > today
      ? new Date(today.getFullYear() - 1, 6, 15)
      : schoolYearStart;

  return { from, to: today };
}
